export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [0,2];

export const dictionary = {
		"/": [~3],
		"/allcharts": [4],
		"/animate-a-bell-curve": [5],
		"/animated-bar-chart": [6],
		"/basics/bar-chart": [7],
		"/basics/basic-shapes": [8],
		"/basics/bidirectional-bar": [9],
		"/basics/density-plot": [10],
		"/basics/donut-chart": [11],
		"/basics/drawing-svg": [12],
		"/basics/dual-axis": [13],
		"/basics/force-simulations": [14],
		"/basics/line-chart": [15],
		"/basics/line-gradient": [16],
		"/basics/scatter-chart-2": [18],
		"/basics/scatter-chart": [17],
		"/basics/stacked-bar-chart": [19],
		"/basics/svelte-5-d3-example": [20],
		"/beeswarm-chart": [~21],
		"/comingsoon": [22],
		"/creating-data": [23],
		"/dna-gel": [24],
		"/du-bois-05": [25],
		"/login": [~26],
		"/maps/svelte-threejs-example": [27],
		"/maps/us-heatmap": [28],
		"/pro-tutorials": [~32],
		"/pro": [~29,[2]],
		"/pro/sankey-chart": [30,[2]],
		"/pro/us-heatmap": [~31,[2]],
		"/register": [~33],
		"/stacked-chart": [34],
		"/us-heatmap": [35],
		"/visualizations/area-chart": [36],
		"/visualizations/sankey-chart": [37],
		"/youtube": [38]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.js';